<template lang="html">
    <div class="storeInfo">
        <div class="store_name">{{detail.sstore_content.sstore_name}}</div>
        <div class="store_address" @click="findPosition">
            <i class="ico ico-icon_52"></i>
            <span>{{detail.sstore_content.sstore_address}}</span>
        </div>
        <div class="work_time">
            <i class="ico ico-icon_44"></i>
            <span>营业时间：{{detail.sstore_content.work_time}}</span>
        </div>
        <div class="phone" @click="handleCallPhone">
            <i class="ico ico-icon_68"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'storeInfo',
    props: {
        /* 服务详情数据 */
        detail : {
            type: Object,
            default () {
                return {}
            }
        }
    },
    components: {
    },
    data () {
        return {
            tabActive: 0
        }
    },
    methods: {
        findPosition () {
            const { lng, lat, sstore_name, sstore_address } = this.detail.sstore_content
            window.location.href = `https://api.map.baidu.com/marker?location=${lat},${lng}&title=${sstore_name}&content=${sstore_address}&output=html&src=webapp.baidu.openAPIdemo`
        },
        /* 打电话 */
        handleCallPhone () {
            const { mobile } = this.detail.sstore_content
            window.location.href = 'tel://' + mobile
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
.storeInfo
    background #fff
    padding 30px
    position relative
    border-top 20px solid #efefef
    border-bottom 20px solid #efefef
    .store_name
        textOverflow()
        font-size 30px
        line-height 45px
        color #333
    .store_address
        fc-flex-direction(row, flex-start, center)
        color #999999
        font-size 24px
        line-height 30px
        margin 30px 0px
        width 500px
        .location
            width 35px
            height 35px
            margin-right 20px
            vertical-align middle
        span
            padding-left 20px
            display inline-block
            mutiLineTextOverFlow(2)
            width 90%
    .work_time
        fc-flex-direction(row, flex-start, center)
        color #999999
        font-size 24px
        line-height 30px
        span
            padding-left 20px
    .phone
        position absolute
        right 46px
        bottom 46px
        line-height 0
        &:after
            content ''
            height 100%
            width 1px
            background #efefef
            position absolute
            left -50px
            top 0
        .phone_img
            width 48px
            height 48px
</style>
